import { render, staticRenderFns } from "./BaseTBodyTD.vue?vue&type=template&id=22654316&"
import script from "./BaseTBodyTD.vue?vue&type=script&lang=js&"
export * from "./BaseTBodyTD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports